import { render, staticRenderFns } from "./DetailsHeading.vue?vue&type=template&id=62149f3e&scoped=true&"
import script from "./DetailsHeading.vue?vue&type=script&lang=js&"
export * from "./DetailsHeading.vue?vue&type=script&lang=js&"
import style0 from "./DetailsHeading.vue?vue&type=style&index=0&id=62149f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62149f3e",
  null
  
)

export default component.exports